export class LatLng{


    latLng:{lat,lng}

    constructor(private lat,private lng){
        
        this.latLng = {lat:this.lat,lng:this.lng};
    }

}


// WEBPACK FOOTER //
// ./src/app/utilities/MapQuest/LatLng.ts